import React from "react";
import { useSelector } from "react-redux";

function Header() {
  const { loading, activeObjOngoingProject } = useSelector((state) => ({
    loading: state.fetch.loading,
    activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
  }));
  return (
    <div className="white_card mt-[2.41rem]">
      <div className="text-[#0092CC] font-interSans font-[500] text-[.75rem]">
        {activeObjOngoingProject?.projectNumber}
      </div>
      <div className="form-add-h !text-[#050505] ">
        {" "}
        {activeObjOngoingProject?.projectName}
      </div>
    </div>
  );
}

export default Header;
